module.exports = __webpack_public_path__ + "img/10-preview.008c6ce9.jpeg";